(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-metaobject-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-faq-summary]');

    if (!summary) {
      return;
    }

    const root = summary.closest('[data-collection-faq]');

    if (!root || root.dataset.allowMultiple === 'true') {
      return;
    }

    const currentItem = summary.parentElement;

    root.querySelectorAll('.collection-metaobject-faq__item[open]').forEach((item) => {
      if (item !== currentItem) {
        item.removeAttribute('open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  const initializeCustomerReviews = (section) => {
    if (!section || section.dataset.carouselInitialized === 'true') return;

    const track = section.querySelector('[data-review-track]');
    const controls = section.querySelector('[data-review-controls]');
    if (!track || !controls || !track.classList.contains('customer-reviews__grid--carousel')) return;

    section.dataset.carouselInitialized = 'true';
    const cards = [...track.querySelectorAll('.customer-review-card')];
    const previous = controls.querySelector('[data-review-previous]');
    const next = controls.querySelector('[data-review-next]');
    const current = controls.querySelector('[data-review-current]');
    let activeIndex = 0;
    let updateFrame;

    const updateControls = () => {
      if (controls.getBoundingClientRect().height === 0) return;

      activeIndex = cards.reduce((closestIndex, card, index) => {
        const currentDistance = Math.abs(card.offsetLeft - track.scrollLeft);
        const closestDistance = Math.abs(cards[closestIndex].offsetLeft - track.scrollLeft);
        return currentDistance < closestDistance ? index : closestIndex;
      }, 0);

      current.textContent = String(activeIndex + 1);
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === cards.length - 1;
    };

    const scrollToCard = (index) => {
      const destination = cards[Math.max(0, Math.min(index, cards.length - 1))];
      track.scrollTo({ left: destination.offsetLeft, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollToCard(activeIndex - 1));
    next.addEventListener('click', () => scrollToCard(activeIndex + 1));
    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(updateFrame);
        updateFrame = requestAnimationFrame(updateControls);
      },
      { passive: true },
    );
    window.addEventListener('resize', updateControls);
    updateControls();
  };

  document.querySelectorAll('[data-customer-reviews-section]').forEach(initializeCustomerReviews);
  document.addEventListener('shopify:section:load', (event) => {
    initializeCustomerReviews(event.target.querySelector('[data-customer-reviews-section]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyTypeDesktop = this.getAttribute('data-sticky-type-desktop') || 'none';
      this.stickyTypeMobile = this.getAttribute('data-sticky-type-mobile') || 'none';
      this.headerBounds = {};
      this.mobileBreakpoint = 750;

      this.updateStickyType();
      this.setHeaderHeight();

      // Listen for viewport changes - store bound references for cleanup
      this.onViewportChangeHandler = this.onViewportChange.bind(this);
      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
      this.mediaQuery = window.matchMedia(`(max-width: ${this.mobileBreakpoint - 1}px)`);
      this.mediaQuery.addEventListener('change', this.onViewportChangeHandler);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeightHandler);

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    updateStickyType() {
      const isMobile = window.innerWidth < this.mobileBreakpoint;
      this.currentStickyType = isMobile ? this.stickyTypeMobile : this.stickyTypeDesktop;
      this.headerIsAlwaysSticky = this.currentStickyType === 'always' || this.currentStickyType === 'reduce-logo-size';
      this.stickyEnabled = this.currentStickyType !== 'none';

      // Update sticky class based on current viewport
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      } else if (!this.stickyEnabled) {
        this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate');
      }
    }

    onViewportChange() {
      this.updateStickyType();
      // Re-evaluate scroll position with new settings
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.mediaQuery && this.onViewportChangeHandler) {
        this.mediaQuery.removeEventListener('change', this.onViewportChangeHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.stickyEnabled) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["independent-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-faq-summary]');

    if (!summary) {
      return;
    }

    const root = summary.closest('[data-independent-faq]');

    if (!root || root.dataset.allowMultiple === 'true') {
      return;
    }

    const currentItem = summary.parentElement;

    root.querySelectorAll('.independent-faq__item[open]').forEach((item) => {
      if (item !== currentItem) {
        item.removeAttribute('open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inquiry-form"] && !Shopify.designMode) return;
  try {
    
  const inquiryFormProductInput = document.getElementById('InquiryForm-product');
  if (inquiryFormProductInput) {
    const inquiryFormParams = new URLSearchParams(window.location.search);
    const inquiryFormProduct = inquiryFormParams.get('product');
    if (inquiryFormProduct && !inquiryFormProductInput.value) {
      inquiryFormProductInput.value = inquiryFormProduct;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["responsive-slideshow"] && !Shopify.designMode) return;
  try {
    
  class ResponsiveSlideshow {
    constructor(container) {
      this.container = container;
      this.slides = Array.from(container.querySelectorAll('[data-slide]'));
      this.dots = Array.from(container.querySelectorAll('[data-dot]'));
      this.prev = container.querySelector('[data-prev]');
      this.next = container.querySelector('[data-next]');
      this.index = 0;
      this.timer = null;
      this.autoplay = container.dataset.autoplay === 'true';
      this.interval = Number(container.dataset.interval) || 5000;
      this.startX = 0;
      this.startY = 0;
      this.isDragging = false;
      this.swiped = false;

      this.bind();
      this.start();
    }

    bind() {
      if (this.prev) {
        this.prev.addEventListener('click', () => this.show(this.index - 1));
      }

      if (this.next) {
        this.next.addEventListener('click', () => this.show(this.index + 1));
      }

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.show(Number(dot.dataset.dot)));
      });

      this.container.addEventListener('mouseenter', () => this.stop());
      this.container.addEventListener('mouseleave', () => this.start());
      this.container.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.container.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.container.addEventListener('pointercancel', () => this.onPointerCancel());
      this.container.addEventListener('click', (event) => this.onClick(event), true);
    }

    onPointerDown(event) {
      if (this.slides.length < 2 || event.pointerType === 'mouse') return;

      this.startX = event.clientX;
      this.startY = event.clientY;
      this.isDragging = true;
      this.swiped = false;
      this.stop();
    }

    onPointerUp(event) {
      if (!this.isDragging) return;

      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;
      const horizontalSwipe = Math.abs(deltaX) > 45;
      const mostlyHorizontal = Math.abs(deltaX) > Math.abs(deltaY) * 1.4;

      this.isDragging = false;

      if (horizontalSwipe && mostlyHorizontal) {
        this.swiped = true;
        this.show(deltaX < 0 ? this.index + 1 : this.index - 1);
      } else {
        this.start();
      }
    }

    onPointerCancel() {
      this.isDragging = false;
      this.start();
    }

    onClick(event) {
      if (!this.swiped) return;

      event.preventDefault();
      event.stopPropagation();
      this.swiped = false;
    }

    show(nextIndex) {
      if (this.slides.length === 0) return;

      this.index = (nextIndex + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.stop();
      this.start();
    }

    start() {
      if (!this.autoplay || this.slides.length < 2 || this.timer) return;
      this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  document.querySelectorAll('[data-responsive-slideshow]').forEach((container) => {
    new ResponsiveSlideshow(container);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-show-carousel"] && !Shopify.designMode) return;
  try {
    
  const initializeTradeShowCarousel = (section) => {
    if (!section || section.dataset.carouselInitialized === 'true') return;

    const track = section.querySelector('[data-trade-show-track]');
    const controls = section.querySelector('[data-trade-show-controls]');
    if (!track || !controls) return;

    const slides = [...track.querySelectorAll('[data-trade-show-slide]')];
    const previous = controls.querySelector('[data-trade-show-previous]');
    const next = controls.querySelector('[data-trade-show-next]');
    const current = controls.querySelector('[data-trade-show-current]');
    if (!slides.length || !previous || !next || !current) return;

    section.dataset.carouselInitialized = 'true';
    let activeIndex = 0;
    let updateFrame;

    const updateControls = () => {
      activeIndex = slides.reduce((closestIndex, slide, index) => {
        const firstOffset = slides[0].offsetLeft;
        const currentDistance = Math.abs(slide.offsetLeft - firstOffset - track.scrollLeft);
        const closestDistance = Math.abs(slides[closestIndex].offsetLeft - firstOffset - track.scrollLeft);
        return currentDistance < closestDistance ? index : closestIndex;
      }, 0);

      current.textContent = String(activeIndex + 1);
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === slides.length - 1;
    };

    const scrollToSlide = (index) => {
      const destination = slides[Math.max(0, Math.min(index, slides.length - 1))];
      track.scrollTo({ left: destination.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollToSlide(activeIndex - 1));
    next.addEventListener('click', () => scrollToSlide(activeIndex + 1));
    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(updateFrame);
        updateFrame = requestAnimationFrame(updateControls);
      },
      { passive: true },
    );
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollToSlide(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollToSlide(activeIndex + 1);
      }
    });
    window.addEventListener('resize', updateControls);
    updateControls();
  };

  document.querySelectorAll('[data-trade-show-carousel]').forEach(initializeTradeShowCarousel);
  document.addEventListener('shopify:section:load', (event) => {
    initializeTradeShowCarousel(event.target.querySelector('[data-trade-show-carousel]'));
  });

  } catch(e) { console.error(e); }
})();
})();
